import { useCallback } from "react";
import {
  getCascadeRequiredValues,
  getCascadeValues,
} from "../../api/Validations";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetCascadeValues() {
  const setCascadeValues = useWorkOrderStore((state) => state.setCascadeValues);
  const setCascadeRequiredValues = useWorkOrderStore(
    (state) => state.setCascadeRequiredValues
  );
  const getCascadedValues = useCallback(async () => {
    /* US 906024 - the cascade "required" flags are pulled alongside the valid values, in the
       same places (offline download, opening the create screen), so no screen pays for an extra
       round trip. Fetched together and stored together: a screen that keys off both would
       otherwise re-run its whole setup once per store write. */
    const [response, requiredResponse] = await Promise.all([
      getCascadeValues(),
      /* Failure is swallowed deliberately: the flags only ADD required-ness on top of the
         element settings, so not having them must never stop a screen from opening or an
         offline download from completing. An empty array is a real answer - a plant with no
         rules configured - and is stored as such so the caller does not keep re-fetching. */
      getCascadeRequiredValues().catch((error) => {
        console.log("Unable to get cascade required values", error);
        return undefined;
      }),
    ]);

    setCascadeValues(response.data);
    setCascadeRequiredValues(
      requiredResponse &&
        !requiredResponse.isError &&
        Array.isArray(requiredResponse.data)
        ? requiredResponse.data
        : []
    );
  }, [setCascadeValues, setCascadeRequiredValues]);
  return { getCascadedValues };
}
